export enum GroupType {
  business = 'business',
  personal = 'personal',
  sector = 'sector',
}

export interface GroupByTypeSummary {
  ownerId?: string | null;
  id: string;
  name: string;
  type: GroupType;
  subtype: string;
  picture: string | null;
  slug: string | null;
}

/** A generic group owner does not imply a trust endorsement. */
export function isTrustCircleGroup(group: { type?: string; subtype?: string }): boolean {
  return group.type === GroupType.personal && group.subtype === 'trust_circle';
}
